import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'

const buttonTextStyle = 'text-base rounded-sm text-blue-700 hover:text-gray-800 focus:text-gray-800 focus:bg-yellow-500'
const textStyle = clsx(
  'border-b border-solid border-blue-700',
  'group-hover:border-gray-800 group-hover:border-b-3 group-focus:border-gray-800 group-focus:border-b-3',
  'transition-border duration-200'
)

export const TextButton = ({
  children,
  startIcon,
  endIcon,
  onClick,
  className,
  linkProps,
  component: El = 'button'
}) => {
  const buttonPropsSetup = linkProps || { type: 'button', onClick }
  return (
    <El className={clsx('group flex gap-2 items-center px-1', buttonTextStyle, className)} {...buttonPropsSetup}>
      {startIcon}
      <span className={textStyle}>{children}</span>
      {endIcon}
    </El>
  )
}

TextButton.propTypes = {
  children: PropTypes.node,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  component: PropTypes.elementType,
  linkProps: PropTypes.shape({
    to: PropTypes.string,
    href: PropTypes.string,
    rel: PropTypes.string,
    target: PropTypes.string
  })
}
